import { MonthView } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { useIsMobile } from '@hooks/useIsMobile';

const MonthDayCell = ({ ...props }: MonthView.DayScaleCellProps) => {
  const isMobile = useIsMobile();

  return (
    <MonthView.DayScaleCell
      {...props}
      style={{ width: isMobile ? '150px' : 'auto' }}
    />
  );
};

export default MonthDayCell;
